import { Component, OnInit, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import * as ptLocale from 'date-fns/locale/pt';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from '../../../util/loader.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { FiltroControleDeAcesso } from '../../../models/controle-acesso/filtroControleDeAcesso';
import { ControleDeAcessoService } from './controle-acesso.service';
import { ModalControleDeAcessoComponent } from './modal-controle-de-acesso/modal-controle-de-acesso.component';
import { ModalVisualizacaoPermissaoComponent } from './modal-visualizacao-permissao/modal-visualizacao-permissao.component';
const swal = require('sweetalert');

@Component({
  selector: 'app-controle-de-acesso',
  templateUrl: './controle-de-acesso.component.html',
  styleUrls: ['./controle-de-acesso.component.scss'],
  animations: [
    trigger('filterBlur', [
      state(
        'hide',
        style({
          opacity: 1
        })
      ),
      state(
        'show',
        style({
          opacity: 0
        })
      ),
      transition('hide => show', animate('200ms ease-in')),
      transition('show => hide', animate('200ms ease-out'))
    ])
  ]
})
export class ControleDeAcessoComponent implements OnInit {
  rows: Object[];
  filtroAgendamento: FiltroControleDeAcesso;
  valForm: FormGroup;
  TipoStatusAgendamento: Array<any>;
  Empresas: Array<any>;
  sortDir = '';
  sortProp = '';
  items: string[];
  grupos: Array<any>;
  parametroConsulta: string;
  blur = false;
  filterState = true;
  page = {
    limit: 50,
    count: 0,
    offset: 0,
    descricao: '',
    ativo: true
  };
  mesagensGrid = {
    emptyMessage: 'Nenhum dado para exibir',
    totalMessage: 'Total de registros',
    selectedMessage: 'Selecionado'
  };

  options: DatepickerOptions = {
    locale: ptLocale,
    displayFormat: 'DD/MM/YYYY',
    barTitleIfEmpty: 'Clique para selecionar a data',
    placeholder: 'Clique para selecionar a data'
  };

  acoesBottoes = true;
  @Input() selected: any[] = [];
  registroSelecao = [];
  selectCheck: any;
  public searchTyped = new BehaviorSubject('');
  // Datepicker
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY HH:mm'
  };
  public modalRef: BsModalRef;
  @ViewChild('tableControleDeAcesso') table: any;

  constructor(public service: ControleDeAcessoService, fb: FormBuilder, public loader: LoadingService, private modalService: BsModalService,) {

    this.parametroConsulta = "";
    this.filtroAgendamento = new FiltroControleDeAcesso();
    this.filtroAgendamento.dataInicio = new Date();
    this.filtroAgendamento.dataFim = new Date();
    this.filtroAgendamento.dataFim.setDate(this.filtroAgendamento.dataInicio.getDate() + 3);



    this.valForm = fb.group({
      dataInicio: [null, Validators.required],
      dataFim: [null, Validators.required],
      grupos: [null, null],
    });



    this.maxDate.setDate(this.maxDate.getDate());
    this.bsRangeValue = [this.bsValue, this.maxDate];
    this.reloadTable();
    this.listarGrupo();
  }

  ngOnInit() {
  }

  listarGrupo() {
    this.loader.show("body");
    this.service.obterGrupos()
      .subscribe((itens) => {
        this.loader.hide("body");
        this.grupos = itens;
      });
  }


  ativarFiltros($event) {
    this.blur = !this.blur;
  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterTodos(this.page, this.sortDir, this.sortProp)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.page.count = itens.count;
        this.rows = itens.rows;
      });

  }

  openModaCriarNovo(event) {
    this.loader.show("body");
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      class: 'modal-lg',
      // size: 'lg', // sm, md, lg
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(ModalControleDeAcessoComponent, config);

    this.modalRef.content.onClose.subscribe(result => {
      if (result.reload) {
        this.reloadTable();
      };
    });

  }

  visualizarAcesso() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {

      this.loader.show("body");
      this.service.obterPermissoes(this.registroSelecao[0].id_grupo_usuario)
        .subscribe(result => {
          this.loader.hide("body");
          const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            animated: true,
            class: 'modal-lg',
            // size: 'lg', // sm, md, lg
            ignoreBackdropClick: true,
            initialState: {
              record: result,
              usuario: this.registroSelecao[0]
            }
          };
          this.modalRef = this.modalService.show(ModalVisualizacaoPermissaoComponent, config);

          this.modalRef.content.onClose.subscribe(result => {
            this.limparSelecionados();
          });
        });
    }
  }

  removerAcesso() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {

      swal({
        title: 'Atenção',
        text: 'Você deseja desativar esse cartão fidelidade?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1E0136',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        closeOnConfirm: false
      }, () => {
        swal.close();

        this.service.removerAcesso(this.registroSelecao[0].id_grupo_usuario)
          .subscribe(result => {
            this.loader.hide("body");
            if (result == true) {
              this.reloadTable();
              this.limparSelecionados();
              swal('Atenção', 'Ação realizada com sucesso.', 'success');
            }
          });
      });
    }
  }
  linkEdit() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.service.obterPorCodigo(this.registroSelecao[0].id_grupo_usuario)
        .subscribe((itens) => {
          this.loader.hide("body");
          const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            animated: true,
            class: 'modal-lg',
            // size: 'lg', // sm, md, lg
            ignoreBackdropClick: true,
            initialState: {
              record: itens
            }
          };
          this.modalRef = this.modalService.show(ModalControleDeAcessoComponent, config);

          this.modalRef.content.onClose.subscribe(result => {
            this.limparSelecionados();
            if (result.reload) {
              this.reloadTable();
            }
          });
        });
    }
  }

  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;

    this.onSelect({ selected: [] });
    this.table.selected = [];

    var inputs = document.getElementsByTagName('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('type') == 'checkbox') {
        inputs[i].checked = false;
      }
    }
  }
  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_empresa == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].id_grupo_usuario == item[0].id_grupo_usuario) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }


  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }

}
